// Actions shared by the staff panel and the public collaborator forms: the
// panel dispatches the bare id, the forms dispatch `{ id, token }` so the
// request carries the form token. Returns `[id, token]`.
export const splitFormTokenPayload = (payload) =>
  payload !== null && typeof payload === 'object' && 'token' in payload
    ? [payload.id, payload.token]
    : [payload, undefined];
